import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatError } from "../../lib/api";
import { Shell } from "./_shell";
import { ConfirmDialog } from "./_shared";

export default function Retailers() {
  const [list, setList] = useState([]);
  const [confirmDel, setConfirmDel] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/retailers").then(r => setList(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const action = async (id, status) => {
    try { await api.put(`/retailers/${id}/approval`, { status }); toast.success(`Retailer ${status}`); load(); }
    catch (e) { toast.error(formatError(e.response?.data?.detail)); }
  };
  const doDelete = async (u) => {
    setBusy(true);
    try {
      await api.delete(`/retailers/${u.id}`);
      toast.success(`${u.business_name || u.email} deleted`);
      setConfirmDel(null); load();
    } catch (e) { toast.error(formatError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <Shell active="retailers">
      <div className="p-5 md:p-10">
        <div className="overline mb-2">Retailer approvals</div>
        <h1 className="font-display text-4xl md:text-6xl uppercase leading-none mb-8">Retailers.</h1>
        <div className="border border-ink overflow-x-auto" data-testid="retailers-table">
          <table className="w-full text-sm min-w-[640px]">
            <thead>
              <tr className="border-b border-ink bg-ink text-paper">
                <th className="text-left p-3 overline">Business</th>
                <th className="text-left p-3 overline">Contact</th>
                <th className="text-left p-3 overline">Status</th>
                <th className="text-right p-3 overline">Actions</th>
              </tr>
            </thead>
            <tbody>
              {list.map(u => (
                <tr key={u.id} className="border-b border-black/10" data-testid={`retailer-${u.id}`}>
                  <td className="p-3"><div className="font-bold">{u.business_name}</div><div className="text-xs text-black/60">{u.email}</div></td>
                  <td className="p-3">{u.contact_name}<div className="text-xs text-black/60">{u.phone}</div></td>
                  <td className="p-3"><span className={`chip ${u.status === "approved" ? "text-cobalt" : u.status === "rejected" ? "text-soda" : "text-safety"}`}>{u.status}</span></td>
                  <td className="p-3 text-right whitespace-nowrap">
                    {u.status !== "approved" && <button onClick={() => action(u.id, "approved")} className="btn-primary mr-2 text-[10px] px-3 py-2" data-testid={`approve-${u.id}`}>Approve</button>}
                    {u.status !== "rejected" && <button onClick={() => action(u.id, "rejected")} className="btn-ghost mr-2 text-[10px] px-3 py-2" data-testid={`reject-${u.id}`}>Reject</button>}
                    <button onClick={() => setConfirmDel(u)} className="text-[10px] px-3 py-2 underline text-soda" data-testid={`delete-retailer-${u.id}`}>Delete</button>
                  </td>
                </tr>
              ))}
              {list.length === 0 && <tr><td colSpan="4" className="p-8 text-center text-black/50">No retailers yet.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
      <ConfirmDialog
        open={!!confirmDel}
        title={`Delete retailer${confirmDel ? `: ${confirmDel.business_name || confirmDel.email}` : ""}?`}
        body={`This permanently removes the retailer account. They will lose access to the portal immediately and any related order history will remain but be orphaned.\n\nUse "Reject" instead if you just want to disable them.`}
        confirmLabel="Delete permanently" danger busy={busy}
        onConfirm={() => doDelete(confirmDel)} onCancel={() => setConfirmDel(null)}
        testid="retailer-delete-dialog"
      />
    </Shell>
  );
}
